import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { Formik } from 'formik';
import { ButtonGroup, IconButton } from '../../../components/Buttons';
import { colors, distances } from '../../../styles/constants';
import { TextareaElement } from '../../../components/Forms/TextAreaElement';
import Icon from '../../../components/Icons';
import { Dropdown } from '../../../components/Forms';

export interface AddCommentProps extends WithTranslation {
    accountId: string;
    orderId: string;
    createComment: (accountId: string, orderId: string, createCommentRequest: { body: string }) => void;
    createCommentIsLoading: boolean;
}

interface FormikErrors {
    body?: string;
}

interface FormikValues {
    body: string;
    visibility: { label: string; value: 'public' } | { label: string; value: 'private' };
}

const visibilityOptions = ['public', 'private'];

class AddCommentForm extends Component<AddCommentProps> {
    render() {
        const { t, accountId, orderId, createComment, createCommentIsLoading } = this.props;
        const labelledVisibilityOptions = visibilityOptions.map((op) => {
            return {
                label: t('orders.order.comments.add_comment.visibility_options.' + op),
                value: op,
            };
        });

        return (
            <Formik
                initialValues={
                    {
                        body: '',
                        visibility: labelledVisibilityOptions[1],
                    } as FormikValues
                }
                validate={(values) => {
                    const errors: FormikErrors = {};

                    if (!values.body) {
                        errors.body = t('orders.order.comments.add_comment.invalid.body');
                    }
                    return errors;
                }}
                validateOnChange={true}
                validateOnMount={true}
                onSubmit={(values, { setFieldValue }) => {
                    const { body, visibility } = values;
                    const createCommentRequest = {
                        body,
                        visibility: visibility.value,
                    };
                    createComment(accountId, orderId, createCommentRequest);
                    setFieldValue('body', '');
                }}
            >
                {({ values, isValid, handleChange, handleBlur, setFieldValue, handleSubmit }) => (
                    <Form onSubmit={handleSubmit} autoComplete="nope">
                        <AddCommentWrapper>
                            <TextareaElement
                                name="body"
                                value={values.body}
                                onChange={handleChange}
                                rightAligned={false}
                                height={distances.large}
                                onBlur={handleBlur}
                            />
                            <AddCommentFooter>
                                <VisibilitySetting>
                                    <span>{t('orders.order.comments.add_comment.visibility_label')}</span>
                                    <VisibilityDropdown
                                        name="visibility"
                                        value={values.visibility}
                                        onChange={(val) => {
                                            setFieldValue('visibility', val);
                                        }}
                                        options={labelledVisibilityOptions}
                                    />
                                </VisibilitySetting>
                                <IconButton
                                    type="submit"
                                    disabled={!isValid || createCommentIsLoading}
                                    placement="left"
                                    icon={<Icon fill="currentColor" icon="document_small" />}
                                >
                                    {t('orders.order.comments.add_comment_button')}
                                </IconButton>
                            </AddCommentFooter>
                        </AddCommentWrapper>
                    </Form>
                )}
            </Formik>
        );
    }
}

export default withTranslation()(AddCommentForm);

const AddCommentWrapper = styled.div``;

const VisibilitySetting = styled.div`
    display: flex;
    align-items: center;

    > span {
        margin-right: ${distances.tiny};
    }
`;

const VisibilityDropdown = styled(Dropdown)`
    width: 100px;
    margin-bottom: 0;
`;

const AddCommentFooter = styled(ButtonGroup)`
    display: flex;
    align-items: center;
`;

const Form = styled.form`
    width: 100%;
`;
